import { AuthByPhoneProvider } from './auth-by-phone.context'

import { useAuthByPhone } from '../../hooks/use-auth-by-phone'
import { CodeBySms } from '../code-by-sms/code-by-sms'
import { CodeByUserCall } from '../code-by-user-call/code-by-user-call'
import { CodeByWebPush } from '../code-by-web-push/code-by-web-push'
import { Error } from '../Error/Error'
import { Phone } from '../Phone/Phone'
import { RegistrationStep } from '../registration-step/registration-step'

import cl from './style.module.scss'

export const AuthByPhone = ({ onSuccess }: { onSuccess?: () => void }) => {
	const auth = useAuthByPhone({ onSuccess })

	if (auth.isAuthError) {
		return (
			<div className={cl.root}>
				<Error />
			</div>
		)
	}

	return (
		<AuthByPhoneProvider value={auth}>
			<div className={cl.root}>
				{auth.step === 'phone' && <Phone />}
				{auth.step === 'call' && <CodeByUserCall />}
				{auth.step === 'sms' && <CodeBySms />}
				{auth.step === 'push' && <CodeByWebPush />}
				{auth.step === 'registration' && <RegistrationStep />}
			</div>
		</AuthByPhoneProvider>
	)
}
